import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { scheduleDocumentScrollLockRelease } from "../utils/scrollLock";

/**
 * Resets the window scroll position to the top on every route change.
 *
 * React Router doesn't do this automatically — without this component, a
 * user who scrolls halfway down the home page and clicks an event card
 * would land on the details page mid-scroll instead of at the hero image.
 *
 * Also releases any stale document scroll locks left behind when a modal,
 * checkout sheet, or mobile menu unmounts out of order during SPA
 * navigation (e.g. navigating to My Tickets right after payment). MUI
 * Dialog can re-apply `overflow: hidden` until its close transition ends,
 * so the release is scheduled across several frames/timeouts.
 *
 * Rendered once inside <BrowserRouter> in App.jsx; returns null.
 *
 * Pathname-only dependency (not full `location`) so an in-page hash
 * change (e.g. `#tickets`) doesn't yank the user back to the top.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useLayoutEffect(() => {
        const cancelRelease = scheduleDocumentScrollLockRelease();
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        return cancelRelease;
    }, [pathname]);

    useEffect(() => {
        const cancelRelease = scheduleDocumentScrollLockRelease();
        return cancelRelease;
    }, [pathname]);

    return null;
}
